import { useFormContext } from 'react-hook-form';

import { Button } from '#atoms';
import { ButtonBox, Container } from 'src/components/pages/Portfolio/styles';
import { ReactNode } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '#api/axios';
import { useToast } from '#providers/ToastProvider';
import { useNavigate, useParams } from 'react-router';

const PortfolioSubmit = ({ children }: { children: ReactNode }) => {
  const { id } = useParams();
  const methods = useFormContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const postMutate = async (data: any) => {
    return await axios.post('/clinical-data/create/direct', data);
  };

  const patchMutate = async (data: any) => {
    return await axios.post(`/clinical-data/patch/${id}`, data);
  };

  const { mutate } = useMutation({
    mutationFn: id ? patchMutate : postMutate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinicalData'] });
      showToast({ message: '트레이닝 성과가 생성되었습니다.' });
      methods.reset();

      return navigate('/profile');
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: '트레이닝 성과 생성에 실패했습니다.'
      });
    }
  });

  return (
    <form
      onSubmit={methods.handleSubmit(data => {
        const { clinicalImages, beforeImages, afterImages, ...rest } = data;
        mutate({
          ...rest,
          clinicalImages: clinicalImages.map((file: any) => file.id),
          beforeImages: beforeImages.map((file: any) => file.id),
          afterImages: afterImages.map((file: any) => file.id)
        });
      })}
    >
      <Container>
        {children}
        <ButtonBox>
          {/* <Button type="button" background="anti">
            미리보기
          </Button> */}
          <Button type="submit">{id ? '수정' : '생성'}하기</Button>
        </ButtonBox>
      </Container>
    </form>
  );
};

export default PortfolioSubmit;
